import { get } from 'lodash';
import { createSelector } from 'reselect';

import { generateIdentifier, generateDatabaseName } from 'Common/DB';
import { isPreferenceEnabled } from 'Common/Security/SecurityHelpers';

const root = state => get(state, 'SecurityState');

export const getId = state => get(root(state), 'userInfo.id', -1);

export const getGuid = state => get(root(state), 'userInfo.userGuid');

export const getFirstName = state => get(root(state), 'userInfo.firstName');

export const getLastName = state => get(root(state), 'userInfo.lastName');

export const getFullName = state => {
  const firstName = getFirstName(state);
  const lastName = getLastName(state);
  return firstName && lastName ? `${firstName} ${lastName}` : undefined;
};

export const getUserName = state => get(root(state), 'userInfo.userName');

export const getRole = state => get(root(state), 'userInfo.role.Description');

export const getRoleId = state => get(root(state), 'userInfo.role.Id');

export const getEmail = state => get(root(state), 'userInfo.email');

export const getShowServingStatus = state =>
  !!get(root(state), 'userInfo.showServingStatus');

export const getUserDistrictName = state =>
  get(root(state), 'userInfo.districtName');

export const getUserDistrictId = state =>
  get(root(state), 'userInfo.districtId');

export const getHash = state => get(root(state), 'hash');

export const getPreferences = state => get(root(state), 'preferences', []);

/**
 * Checks if user has the preference enabled
 * @param {Object} state
 * @param {Integer} preference
 */
export const getPreferenceEnabled = (state, preference) =>
  isPreferenceEnabled(preference, getPreferences(state));

export const getAccessInfo = state => get(root(state), 'accessInfo', []);

export const getAccessGroupEnabled = createSelector(
  [getAccessInfo, (state, groupName) => groupName],
  (accessInfo, groupName) => {
    const accessGroupEnabled = accessInfo.find(
      item =>
        item.GroupName.toLowerCase() === groupName.toLowerCase() &&
        item.WriteAccess
    );
    return !!accessGroupEnabled;
  }
);

export const getDatabaseName = state => {
  const district = getUserDistrictId(state);
  const username = getUserName(state);
  const identifier = generateIdentifier(district, username);
  return generateDatabaseName(identifier);
};

export const getIsLoggedIn = createSelector(getUserName, userName =>
  Boolean(userName)
);



// WEBPACK FOOTER //
// ./src/common/Security/state/selectors.js